import { render, staticRenderFns } from "./VocabularyAutocomplete.vue?vue&type=template&id=082cc0ec&scoped=true&"
import script from "./VocabularyAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VocabularyAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyAutocomplete.vue?vue&type=style&index=0&id=082cc0ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082cc0ec",
  null
  
)

export default component.exports